// Fallback for rows fetched before the backend backfilled `code` (or any
// other edge case where it's momentarily absent) -- mirrors the same
// FCS-<id> default the backend applies in schemas.VideoRead.
export const videoCode = (video) => video?.code || `FCS-${video?.id}`;
